import { SET_CONFIG_ADMIN } from "../actions/setConfig";
import { SAVING_CONFIG, SAVED_CONFIG } from "../actions/setImagesToMainSliderByCityAdmin";

export const config = (state = {}, action) => {
    switch(action.type) {
        case SET_CONFIG_ADMIN: {
            return action.payload;
        }
        default:
            return state;
    }
}

export const isSavingConfig = (state = {}, action) => {
    switch(action.type) {
        case SAVING_CONFIG: {
            return action.payload;
        }
        default:
            return state;
    }
}

export const isSavedConfig = (state = {}, action) => {
    switch(action.type) {
        case SAVED_CONFIG: {
            return action.payload;
        }
        default:
            return state;
    }
}